import styled from "styled-components/macro";

export const LoginPageWrapper = styled.div`
  height: 100vh;
  background-color: #cbcccb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
`;

export const Logo = styled.div`
  padding: 1.5rem 0;
  flex: 1 1 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Layer = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  background-image: url("https://www.morganprojects.co.nz/resources/images/services/landingflood.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 329px;
  top: 0px;
  left: 0px;
  opacity: 1;
  background-position: center center;
  background-repeat: no-repeat no-repeat;
`;

export const LoginCard = styled.div`
  display: flex;
  background-color: rgba(29, 29, 29, 0.8);
  max-width: 500px;
  min-width: 290px;
  min-height: 200px;
  width: 100%;
  box-shadow: 2px 2px rgba(0, 0, 0, 0.1);
  position: relative;
  flex-direction: column;
  word-wrap: break-word;
  background-clip: border-box;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  border-top: 1px solid hsl(0, 0%, 80%);
  flex: 1 1 auto;
  width: 100%;
  font-size: 0.8rem;
`;

export const Stripe = styled.div`
  position: absolute;
  width: 100%;
  height: 108px;
  background-color: #660516; // rgba(102, 5, 22);
  background-color: rgba(76, 16, 23);
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: 100%;
  padding: 2rem 3rem;
`;

export const Label = styled.span`
  color: #fff;
  text-transform: uppercase;
  padding-right: 2rem;
  font-size: 1rem;
  line-height: 28px;
  width: 120px;
`;

export const FormGroup = styled.div`
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin: 0;
`;

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  z-index: 0;
  width: 100%;
`;

export const Input = styled.input`
  outline: none;
  background-color: #fff;
  border: 1px solid rgba(29, 29, 29);
  color: rgba(29, 29, 29);
  width: 270px;
  height: 40px
  padding-left: 0.5rem;
  flex: 1 1 auto;

  box-shadow: 0;
  :focus {
    box-shadow: 0 0 5px rgba(118, 13, 23, 1);
    border: 2px solid rgba(118, 13, 23, 0.5);
    background-color: rgba(115, 115, 115);
    background-color: #fff;
    color: rgba(29, 29, 29);
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1 1 70px;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const LinkWrapper = styled.span`
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
`;

export const Button = styled.button`
  width: 150px;
  height: 40px;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  background-color: #7d7d7d;
  border-radius: 0px 0px 0px 0px;
  outline: none;

  :disabled {
    color: #868686;
    border-color: #868686;
    background-color: #565454;
    :hover {
      background-color: #565454;
    }
  }

  :hover {
    background-color: #656363;
  }

  :focus {
    border: 1px solid rgba(118, 13, 23, 0.5);
    outline: 1px solid rgba(118, 13, 23, 1);
    border-radius: 0;
  }
`;

export const Link = styled.a`
  color: #fff;
  padding-right: 2rem;
  vertical-align: center;
  cursor: pointer;

  :hover {
    color: rgba(118, 13, 23, 1);
  }
`;

export const FooterClass = styled.div`
  flex-direction: column;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end;
  padding-top: 0.5rem;
  min-height: 100px;
`;

export const LoginHeadline = styled.h2`
  color: #fff;
  text-transform: uppercase;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
`;

export const LoginDescription = styled.p`
  color: #ddd;
  margin-bottom: 1rem;
`;

export const MicrosoftButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid #8c8c8c;
  height: 41px;
  padding: 0 12px;
  font-family: "Segoe UI", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #555555;
  cursor: pointer;
  min-width: 270px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon {
    margin-right: 12px;
    height: 20px;
    width: 20px;
  }

  .spinner {
    position: absolute;
    left: 12px;
    width: 20px;
    height: 20px;
  }
`;
